import { COUNTRIES } from 'utils/countries.utils';

export const getCountryLabelFromCode = (code?: string) => {
  if (!code || code === 'Unknown') {
    return 'Unknown';
  }
  return COUNTRIES.find(country => country.code === code.toUpperCase())?.label || 'Unknown';
};

export const getCountryRiskLevelFromCode = (code?: string) => {
  if (!code || code === 'Unknown') {
    return undefined;
  }
  return COUNTRIES.find(country => country.code === code.toUpperCase())?.riskLevel;
};
